import _MessageBox2 from "element-ui/lib/theme-chalk/message-box.css";
import "element-ui/lib/theme-chalk/base.css";
import _MessageBox from "element-ui/lib/message-box";
import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _Loading2 from "element-ui/lib/theme-chalk/loading.css";
import "element-ui/lib/theme-chalk/base.css";
import _Loading from "element-ui/lib/loading";
import _TopHeader2 from "tvu-common-ui/lib/style/top-header.css";
import _TopHeader from "tvu-common-ui/lib/top-header";
import _HelpCenter2 from "tvu-common-ui/lib/style/help-center.css";
import _HelpCenter from "tvu-common-ui/lib/help-center";
import _ServiceJumpCollect2 from "tvu-common-ui/lib/style/service-jump-collect.css";
import _ServiceJumpCollect from "tvu-common-ui/lib/service-jump-collect";
import _BackAndFrontVersion2 from "tvu-common-ui/lib/style/back-and-front-version.css";
import _BackAndFrontVersion from "tvu-common-ui/lib/back-and-front-version";
/* eslint-disable indent */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from '@/assets/js/axiosExtend.js';
import VueAxios from 'vue-axios';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/index.less';
import '@/assets/iconfont/iconfont.css';
import VueClipboard from 'vue-clipboard2';
import '@/assets/iconfont/iconfont.js';
import '@/assets/js/webrtcClient.js';
import Scroll from '@/directive/scroll'; // Scroll loading
import filters from '@/assets/js/filter';
import i18n from '@/lang';
import 'babel-polyfill';
import locale from 'element-ui/lib/locale';
VueClipboard.config.autoSetContainer = true;
// 遍历注册全局过滤器
Object.keys(filters).forEach(key => Vue.filter(key, filters[key]));
Vue.prototype.$backAndFrontVersion = _BackAndFrontVersion;
Vue.config.productionTip = false;
locale.i18n((key, value) => i18n.t(key, value));
const topBarNeedElement = [require('element-ui/lib/drawer').default, require('element-ui/lib/dialog').default, require('element-ui/lib/tooltip').default, require('element-ui/lib/popover').default, require('element-ui/lib/button').default, require('element-ui/lib/input').default, require('element-ui/lib/tabs').default, require('element-ui/lib/tab-pane').default, require('element-ui/lib/dialog').default];
topBarNeedElement.forEach(Comp => {
  Vue.component(Comp.name, Comp);
});
Vue.use(VueClipboard);
Vue.use(VueAxios, axios);
Vue.use(Scroll);
Vue.use(_ServiceJumpCollect);
Vue.use(_HelpCenter);
Vue.use(_TopHeader);
Vue.use(_Loading.directive);
// Vue.use(VolumeBar)
// 定义一个新的Message方法，多传入一个offset参数
const $message = options => {
  if (options.single) {
    if (document.getElementsByClassName('el-message').length === 0) {
      return _Message({
        ...options,
        offset: 50,
        showClose: true
      });
    }
  } else {
    return _Message({
      ...options,
      offset: 50,
      showClose: true
    });
  }
}

// 重写一遍success的方法,将offset写入options
;
['success', 'warning', 'info', 'error'].forEach(type => {
  $message[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options,
        offset: 50,
        showClose: true
      };
    }
    options.type = type;
    if (options.single) {
      if (document.getElementsByClassName('el-message').length === 0) {
        return _Message(options);
      }
    } else {
      return _Message(options);
    }
  };
});
// 将$message挂载到this上
Vue.prototype.$message = $message;
Vue.prototype.$confirm = _MessageBox.confirm;
Vue.prototype.$cm = $cm; // $cm在index.html加载的js

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app');